// Slot Qualification Keys (used across the app)
export const SLOT_QUALIFICATION_ENDPOINT = 'endpoint';
export const SLOT_QUALIFICATION_PROXY_URL = 'proxy-url';
export const SLOT_QUALIFICATION_AD_ID = 'ad-id';
export const SLOT_QUALIFICATION_REQUEST_BODY = 'request-body';
export const SLOT_QUALIFICATION_RESPONSE_BODY = 'response-body';

// Slot Qualification Request Metadata Keys
export const SLOT_QUALIFICATION_APP = 'publisher';
export const SLOT_QUALIFICATION_SESSION_TYPE = 'session-type';
export const SLOT_QUALIFICATION_CONTENT_TYPE = 'playback-type';
export const SLOT_QUALIFICATION_CONTENT_RATING = 'content-rating';

// Slot Qualification Detail Keys
export const SLOT_QUALIFICATION_INVARIANT_QUALIFIED = 'invariantQualified';
export const SLOT_QUALIFICATION_SLOT_QUALIFIED = 'slotQualified';
export const SLOT_QUALIFICATION_DQ_STATUS = 'dqStatus';
export const SLOT_QUALIFICATION_SELECTION = 'selection';
export const SLOT_QUALIFICATION_POD_POSITION = 'podPosition';
export const SLOT_QUALIFICATION_SLOT_POSITION = 'slot-number';
export const SLOT_QUALIFICATION_QUALIFIED_ADS = 'qualifiedAds';
export const SLOT_QUALIFICATION_FILLER_ONLY = 'filler-only';
export const SLOT_QUALIFICATION_DQ_REASON = 'dqReason';
export const SLOT_QUALIFICATION_IN_NEXT_SEQUENCE = 'in-sequence';
export const SLOT_QUALIFICATION_DQ_FILTER = 'disqualifying-filter';
export const SLOT_QUALIFICATION_DQ_DIMENSION = 'disqualifying-dimension';
export const SLOT_QUALIFICATION_ADS_IN_SEQUENCE = 'next-sequenced-ads';

// Invariant Qualification Keys (used across the app)
export const INVARIANT_QUALIFICATION_ENDPOINT = 'endpoint';
export const INVARIANT_QUALIFICATION_AD_ID = 'ad-id';
export const INVARIANT_QUALIFICATION_PROXY_URL = 'proxy-url';
export const INVARIANT_QUALIFICATION_REQUEST_BODY = 'request-body';
export const INVARIANT_QUALIFICATION_RESPONSE_BODY = 'response-body';
export const INVARIANT_QUALIFICATION_APP = 'publisher';
export const INVARIANT_QUALIFICATION_SESSION_TYPE = 'session-type';
export const INVARIANT_QUALIFICATION_CONTENT_TYPE = 'playback-type';
export const INVARIANT_QUALIFICATION_CONTENT_RATING = 'content-rating';

// Invariant Detail Panel Keys (used only in InvariantQualificationDetailPanel)
export const INVARIANT_QUALIFICATION_DQ_STATUS = 'dq-status';
export const INVARIANT_QUALIFICATION_DQ_FILTER = 'disqualifying-filter';
export const INVARIANT_QUALIFICATION_DQ_DIMENSION = 'disqualifying-dimension';
export const INVARIANT_QUALIFICATION_RESTRICTION_RULES = 'restriction-rules';
export const INVARIANT_QUALIFICATION_QUALIFIED_ADS = 'qualified-ads';
export const INVARIANT_QUALIFICATION_DQ_REASON = 'dqReason';
